export const meta = {
  title: '常见问题',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'troubleshooting'],
};

运营者真正会问的问题，配上简短的回答。每一条都指向手册里更完整的文章。

## 上线要多久？

几分钟。注册只有四个字段、不需要银行卡，欢迎向导帮您配好门店、营业时间和 Logo，**打印 QR** 给您顾客要扫的码。完整流程见*快速上手*。前 14 天是全功能免费试用。

## 顾客需要下载 App 吗？

不需要。他们扫您的 QR，您的应用就在浏览器里打开——没有应用商店，没有下载。他们*可以*把它加到主屏幕，让它像装好的 App 一样，但不加也一切正常。

## 顾客看到的是我的名字，还是网络的？

您的。您的名字、您的 Logo、您的配色。网络只以一行小字“网络成员”出现。见*品牌*。

## 试用结束后会怎样？

您的套餐开始按月后付计费：每月 1 号后不久出一张覆盖上个月的账单，在账单页用 FPX 支付即可。每笔费用都逐项列明——见*账单与订阅*。

## 一个账户能开几家门店吗？

能。在门店页添加即可；每家门店有自己的队列和 QR 码，确认前会预览按天分摊的费用。员工可以按门店分配。

## 散客（walk-in）能积分吗？

只有登录的顾客才积分——没有顾客账户的散客工单什么也拿不到。这正是引导常客扫您 QR 的最好理由。见*会员积分*。

## 为什么群发触达的人比我的顾客数少？

三道保护性关卡：营销退订、免打扰时段、以及从未允许通知的顾客。发送摘要逐项点名，差额从不成谜。见*营销群发*。

## 用代理代码要花我的钱吗？

不用。有没有代码价格一样。代理由网络一侧按注册赚取一次性佣金——绝不出自您的账单。见*代理代码与推荐*。

## 顾客不下单也能看到我的价格吗？

能——您的套餐、加购项和价格在您的应用里是公开的。拿到您链接或 QR 的任何人都能先浏览再决定。

## 平台支持哪些语言？

控制台、您的顾客应用和这本手册都提供 English、Bahasa Melayu、中文和தமிழ்——顾客在应用里自选语言。一个诚实的缺口：推送通知的文案目前固定为英文。见*通知*。

## 每位员工都有自己的登录吗？

有。在员工页用手机号邀请，他们用一次性验证码登录——没有密码要管理。角色（店长、收银、洗车工）精确控制每个人能碰什么。见*员工与角色*。

## 怎样让门店上公共查找目录？

打开营业时间页底部的**在公共目录展示我的门店**。它默认关闭——没有人会在未主动选择的情况下被列出。开了还没出现的话，*故障排查*里有核对清单。
